
        import { createElement as _createElement } from 'react';
import { Fragment as _Fragment } from 'react';
import _map from 'lodash-es/map';
export default function relatedItemsRT () {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                return _createElement('product-item', { 'class': 'product-item' }, _createElement('div', { 'className': 'product-item__image-wrapper' + (this.image2 ? ' product-item__image-wrapper--multiple' : '') }, _createElement('div', { 'className': 'product-item__label-list label-list' }, this.on_sale ? _createElement('span', {
                    'className': 'label label--highlight',
                    'key': '221'
                }, '\n        Save ', this.formatPrice(this.compare_at_price - this.price), '\n      ') : null, this.special_offer ? _createElement('span', {
                    'className': 'label label--special_offer',
                    'key': '370'
                }, 'Special Offer') : null), _createElement('a', {
                    'href': this.url,
                    'data-instant': true,
                    'className': 'product-item__aspect-ratio aspect-ratio aspect-ratio--short'
                }, _createElement('img', {
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'alt': this.removeHTML(this.title),
                    'onError': this.onImageError,
                    'className': 'product-item__primary-image'
                }), this.image2 ? _createElement('img', {
                    'src': this.resizeImage(this.image2),
                    'alt': this.removeHTML(this.title),
                    'onError': e => this.onImageError(e, 'image2'),
                    'className': 'product-item__secondary-image',
                    'key': '759'
                }) : null), _createElement('form', {
                    'method': 'post',
                    'action': '/cart/add',
                    'id': 'product_form_template--18313235824793__main__' + this.id,
                    'acceptCharset': 'UTF-8',
                    'encType': 'multipart/form-data',
                    'is': 'product-form'
                }, this.variant_ids.length > 1 ? [_createElement('a', {
                        'className': 'button button--primary button--text button--full hidden-touch',
                        'href': this.url,
                        'aria-label': 'button',
                        'key': '11481'
                    }, '\n          ', this.out_of_stock ? 'Sold out' : 'Select options', '\n        ')] : null, this.variant_ids.length === 1 ? [
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'form_type',
                        'value': 'product',
                        'key': '14421'
                    }),
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'utf8',
                        'value': '\u2713',
                        'key': '14423'
                    }),
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'quantity',
                        'value': '1',
                        'key': '14425'
                    }),
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'id',
                        'value': this.variant_ids,
                        'key': '14427'
                    }),
                    _createElement('button', {
                        'type': 'submit',
                        'className': 'button button--primary button--text button--full hidden-touch',
                        'disabled': this.out_of_stock,
                        'key': '14429'
                    }, !this.out_of_stock ? [
                        '\n            Add to cart',
                        this.set_qty ? ` Set of ${ this.set_qty }` : '',
                        '\n          '
                    ] : null, this.out_of_stock ? ['Sold out'] : null, _createElement('span', {
                        'className': 'loader-button__loader',
                        'hidden': true
                    }, _createElement('div', { 'className': 'spinner' }, _createElement('svg', {
                        'focusable': 'false',
                        'width': '24',
                        'height': '24',
                        'className': 'icon icon--spinner',
                        'viewBox': '25 25 50 50'
                    }, _createElement('circle', {
                        'cx': '50',
                        'cy': '50',
                        'r': '20',
                        'fill': 'none',
                        'stroke': 'currentColor',
                        'strokeWidth': '5'
                    }))))),
                    _createElement('button', {
                        'type': 'submit',
                        'className': 'product-item__quick-buy-button hidden-no-touch',
                        'disabled': this.out_of_stock,
                        'key': '144211'
                    }, !this.out_of_stock ? _createElement('span', {
                        'className': 'visually-hidden',
                        'key': '2609'
                    }, '\n            Add to cart', this.set_qty ? ` Set of ${ this.set_qty }` : '', '\n          ') : null, this.out_of_stock ? _createElement('span', {
                        'className': 'visually-hidden',
                        'key': '2781'
                    }, 'Sold out') : null, _createElement('svg', {
                        'focusable': 'false',
                        'width': '24',
                        'height': '24',
                        'className': 'icon icon--quick-buy-shopping-bag',
                        'fill': 'none',
                        'viewBox': '0 0 24 24'
                    }, _createElement('path', {
                        'd': 'M14 4H5L4 20H20C19.7517 16.0273 19.375 10 19.375 10',
                        'stroke': 'currentColor',
                        'strokeWidth': '2'
                    }), _createElement('path', {
                        'd': 'M9 7V7C9 8.65685 10.3431 10 12 10V10C13.6569 10 15 8.65685 15 7V7',
                        'stroke': 'currentColor',
                        'strokeWidth': '2'
                    }), _createElement('path', {
                        'd': 'M20 0V8M16 4H24',
                        'stroke': 'currentColor',
                        'strokeWidth': '2'
                    }))),
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'product-id',
                        'value': this.id,
                        'key': '144213'
                    }),
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'section-id',
                        'value': 'template--18313235824793__main',
                        'key': '144215'
                    })
                ] : null)), _createElement('div', { 'className': 'product-item__info' }, _createElement('div', { 'className': 'product-item-meta' }, this.vendor && this.vendor_url ? _createElement('a', mergeProps({
                    'className': 'product-item-meta__vendor heading heading--xsmall text--subdued',
                    'href': this.vendor_url,
                    'key': '3612'
                }, { dangerouslySetInnerHTML: { __html: this.vendor } })) : null, _createElement('a', mergeProps({
                    'href': this.url,
                    'data-instant': true,
                    'className': 'product-item-meta__title'
                }, { dangerouslySetInnerHTML: { __html: this.title } })), _createElement('div', { 'className': 'product-item-meta__price-list-container' }, _createElement('div', { 'className': 'price-list price-list--centered' }, this.on_sale ? [
                    _createElement('span', {
                        'className': 'price price--highlight',
                        'key': '40841'
                    }, _createElement('span', { 'className': 'visually-hidden' }, 'Sale price'), '\n              ', this.formatPrice(this.price), '\n            '),
                    _createElement('span', {
                        'className': 'price price--compare',
                        'key': '40843'
                    }, _createElement('span', { 'className': 'visually-hidden' }, 'Regular price'), '\n              ', this.formatPrice(this.compare_at_price), '\n            ')
                ] : null, !this.on_sale ? [_createElement('span', {
                        'className': 'price',
                        'key': '45201'
                    }, _createElement('span', { 'className': 'visually-hidden' }, 'Sale price'), '\n              ', this.formatPrice(this.price), '\n            ')] : null)))));
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, 'You might also like...')), _createElement.apply(this, [
        'div',
        { 'className': 'cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []